"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
var object_1 = require("./object");
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(name, weight) {
        var _this = _super.call(this, (name ? name : "") + "Progress") || this;
        _this.children = [];
        _this.currentProgress = 0;
        _this.name = name;
        _this.weight = weight || 1;
        return _this;
        //this.log.info('created');
    }
    Progress.prototype.child = function (name, weight) {
        var childName = this.toString() + "child" + name ? name : "";
        var child = new Progress(childName, weight);
        this.children.push(child);
        return child;
    };
    Progress.prototype.add = function (valueFrom0To100) {
        var newValue = this.currentProgress + valueFrom0To100;
        this.set(newValue);
    };
    Progress.prototype.set = function (valueFrom0To100) {
        this.currentProgress = Math.min(100, valueFrom0To100);
        //this.log.info('updated', this.currentProgress); //слишком много эвентов генерит
        if (this.children.length > 1) {
            this.log.warn("has child. Current value will be ignored");
        }
    };
    Progress.prototype.complete = function () {
        this.set(100);
    };
    Progress.prototype.eliminate = function () {
        this.weight = 0;
        this.complete();
    };
    Progress.prototype.subscribe = function (promise, cb, interval) {
        var _this = this;
        cb.call(null, this.current());
        var intervalId = setInterval(function () { return cb.call(null, _this.current()); }, interval || 200);
        return promise.then(function (r) {
            cb.call(null, _this.current());
            clearInterval(intervalId);
            return r;
        }, function (e) {
            clearInterval(intervalId);
            throw e;
        });
    };
    Progress.prototype.current = function () {
        if (this.children.length === 0) {
            //this.log.debug('current', this.currentProgress);
            return this.currentProgress;
        }
        var childrenTotalProgress = this.children
            .map(function (c) { return c.current() * c.weight; })
            .reduce(function (a, b) { return a + b; }, 0);
        var childrenTotalWeight = this.children
            .map(function (c) { return c.weight; })
            .reduce(function (a, b) { return a + b; }, 0);
        if (childrenTotalWeight === 0)
            return 100;
        var totalProgressWithWeight = childrenTotalProgress / childrenTotalWeight;
        //this.log.debug('current', totalProgressWithWeight);
        return totalProgressWithWeight;
    };
    return Progress;
}(object_1.BaseObject));
exports.Progress = Progress;
